<template>
  <div class="modal fade cancel-sale-modal" id="CancelSaleModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Cancelar venda</h1>
                  <button type="button" class="btn-close cancel-sale-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formCancelSale" @submit.prevent="cancelSaleMethod">
                <div class="modal-body ps-30 pe-30">
                  <p>Tem certeza que deseja cancelar a venda de <strong>{{ getCurrentViewSale.user ? getCurrentViewSale.user.name : '' }}</strong> ?</p>
                  <p>Esta ação não poderá ser desfeita.</p>
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="password_sale_cancel" class="form-label fw-medium"
                      >Senha do sistema</label
                    >
                    <input
                      type="password"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="password_sale_cancel"
                      autocomplete="off"
                      required
                    />
                  </div>

                  <div class="col-12">
                    <div id="alertResponseApiCancelSale" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageCancelSale">
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                
                <div class="modal-footer">
                  <button type="submit" ref="buttonCancelSale" class="btn btn-dark">Cancelar venda</button>
                  <button type="button" class="btn btn-secondary cancel-sale-modal" data-bs-dismiss="modal">Cancelar</button>
                </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '../../config/axios.js';

export default {
  name: "CancelSaleModal",
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      'getCurrentViewSale'
    ])
  },
  methods: {
    cancelSaleMethod() {
      event.preventDefault();

      if (
        document.getElementById("password_sale_cancel") == undefined ||
        document.getElementById("password_sale_cancel").value == ""
      ) {
        this.alertResponse("Por favor preencha a senha", true);
        return;
      }

      const password_sale_cancel = document.getElementById("password_sale_cancel").value;
      const sale_id = this.getCurrentViewSale.id;

      const objSaleCancel = {
        password: password_sale_cancel
      };

      const buttonCancelSale = this.$refs.buttonCancelSale;
      buttonCancelSale.disabled = true;
      buttonCancelSale.innerHTML = "Cancelando...";
      const alertResponse = this.alertResponse;

      api.axios.post(`/api/sales/${sale_id}/delete`, objSaleCancel).catch(function(error) {
        if (error.response?.data != undefined) {
          buttonCancelSale.innerHTML = "Cancelar venda";
        }
        console.log("error", error);
        alertResponse(error.response?.data || "Erro ao cancelar venda", true);
        buttonCancelSale.disabled = false;
      }).then(function(response) {
        if (response != undefined && (response.status == 200 || response.status == 201)) {
          buttonCancelSale.innerHTML = "Venda cancelada com sucesso!";
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } else {
          buttonCancelSale.disabled = false;
          buttonCancelSale.innerHTML = "Cancelar venda";

          document.getElementById("password_sale_cancel").value = "";
        }
      });
    },
    alertResponse(message, error) {
      const warningMessage = `<i class="flaticon flaticon-warning"></i> ${message}`;
      const successMessage = `<i class="flaticon flaticon-check"></i> ${message}`;

      if (error) {
        document.getElementById("errorMessageCancelSale").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageCancelSale").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiCancelSale");
      if (elementAlert) {
        if (error) {
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 7000);
      }

      const password = document.getElementById("password_sale_cancel");
      if (password) {
        password.value = "";
      }
    }
  }
};
</script>
